export const ART_PROVIDER_LOCAL = 2;
export const ART_PROVIDER_IMS = 3;
